export default __webpack_public_path__ + "static/media/pomodoro-clock-mobile.d766df67.png";